import { AUTH_API, handleApiError } from '../../utils/axios';

export const getVisits = async (search, vin) => {
  try {
    const { data } = await AUTH_API.get(
      `/api/v1/vehicles/${vin}/visits?page=${search.page}&size=${search.size}&search=${search.search}`,
    );
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createVisit = async (vin) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/vehicles/${vin}/visits`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
